import React from 'react';
import { createPortal } from 'react-dom';
import { CheckCircle2, AlertTriangle, XCircle, Info, X } from 'lucide-react';

export function Toast({
  message,
  type = 'info', // 'success' | 'warning' | 'danger' | 'info'
  onClose,
  visible = true
}) {
  if (!visible || !message) return null;

  const icons = {
    success: <CheckCircle2 size={18} color="#10B981" />,
    warning: <AlertTriangle size={18} color="#F59E0B" />,
    danger: <XCircle size={18} color="#EF4444" />,
    info: <Info size={18} color="#38BDF8" />
  };

  const borders = {
    success: '#059669',
    warning: '#D97706',
    danger: '#DC2626',
    info: '#0284C7'
  };

  const toastContent = (
    <div
      style={{
        position: 'fixed',
        bottom: '24px',
        right: '24px',
        zIndex: 100000,
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '14px 20px',
        background: '#1E293B',
        border: `1px solid ${borders[type]}`,
        borderRadius: 'var(--radius-md)',
        color: '#FFFFFF',
        fontSize: '14px',
        fontWeight: 500,
        boxShadow: '0 10px 25px -5px rgba(0,0,0,0.5)',
        animation: 'fadeIn 0.3s cubic-bezier(0.16, 1, 0.3, 1)'
      }}
    >
      {icons[type]}
      <span>{message}</span>
      {onClose && (
        <button
          onClick={onClose}
          type="button"
          style={{
            background: 'none',
            border: 'none',
            color: 'var(--text-dim)',
            cursor: 'pointer',
            padding: '2px',
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <X size={16} />
        </button>
      )}
    </div>
  );

  return createPortal(toastContent, document.body);
}

export default Toast;
